// db.js
import Dexie from "dexie";
import cryptoUtils from "../utils/cryptoUtils";
import { toast } from "react-toastify";
import { CONFIGS } from "../constants/AppConstant";

const ExpenseTrackingMetadataDB = new Dexie(`ExpenseTrackingAIMetadataDB_${CONFIGS.STAGE}`);

ExpenseTrackingMetadataDB.version(1).stores({
  items: "&id, userId, data",
});

async function putItemToExpenseTrackingMetadata(item) {
  const id = item.expenseId;
  const userId = item.userId;
  const data = cryptoUtils.encryptObjectToString(item);
  return ExpenseTrackingMetadataDB.items.put({ id, userId, data });
}

async function getAllTrackingSpends() {
  const items = (await ExpenseTrackingMetadataDB.items.toArray()) || [];
  return items
    .map((item) => {
      const { data } = item;
      const expenseItem = cryptoUtils.decryptToObject(data);
      return { ...expenseItem, total: Number(expenseItem.total) };
    })
    .sort((a, b) => {
      if (b.purchasedDate === a.purchasedDate) {
        return new Date(b.lastModifiedDate) - new Date(a.lastModifiedDate);
      }
      return new Date(b.purchasedDate) - new Date(a.purchasedDate);
    });
}
async function deleteAllItems() {
  await ExpenseTrackingMetadataDB.items.clear();
}
async function deleteItemFromExpenseTrackingMetadata(expenseId) {
  try {
    await ExpenseTrackingMetadataDB.items.delete(expenseId);
  } catch (error) {
    console.error("Error deleting item:", error);
    toast.error("Failed to delete item");
  }
}
export default {
  getAllTrackingSpends,
  putItemToExpenseTrackingMetadata,
  deleteAllItems,
  deleteItemFromExpenseTrackingMetadata,
};
